var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.9833 3.33337H13.0166C6.94992 3.33337 3.33325 6.95004 3.33325 13.0167V26.9667C3.33325 33.05 6.94992 36.6667 13.0166 36.6667H26.9666C33.0333 36.6667 36.6499 33.05 36.6499 26.9834V13.0167C36.6666 6.95004 33.0499 3.33337 26.9833 3.33337Z",
    fill: "#1E5EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4833 13.5167C24.0167 11.0667 20.0167 11.0667 17.5667 13.5167C15.85 15.2167 15.3333 17.6834 16 19.85L12.0833 23.7667C11.8167 24.05 11.6167 24.6 11.6833 25L11.9333 26.8167C12.0167 27.4167 12.5833 27.9834 13.1833 28.0667L15 28.3334C15.4 28.3834 15.95 28.2167 16.2333 27.9167L16.9167 27.2334C17.0833 27.0834 17.0833 26.8167 16.9167 26.65L15.3 25.0334C15.0667 24.8 15.0667 24.4 15.3 24.15C15.5333 23.9167 15.9333 23.9167 16.1833 24.15L17.8 25.7667C17.95 25.9167 18.2167 25.9167 18.3833 25.7667L20.15 24.0167C22.3 24.6834 24.7667 24.1667 26.4833 22.4667C28.95 19.9834 28.95 15.9834 26.4833 13.5167ZM22.0833 20C20.9333 20 20 19.0667 20 17.9167C20 16.7667 20.9333 15.8334 22.0833 15.8334C23.2333 15.8334 24.1667 16.7667 24.1667 17.9167C24.1667 19.0667 23.2333 20 22.0833 20Z",
    fill: "#1E5EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/key-icon.8d0c2fecf3212281df7b3ee841aee662.svg";
export { ForwardRef as ReactComponent };